/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGenderDemigirl = createReactComponent("outline", "gender-demigirl", "IconGenderDemigirl", [["path", { "d": "M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M12 14v7", "key": "svg-1" }], ["path", { "d": "M9 18h3", "key": "svg-2" }]]);

export { IconGenderDemigirl as default };
//# sourceMappingURL=IconGenderDemigirl.mjs.map
